module.exports = new __parcel__URL__("CineBriqueVQ.97bce5b1.jpeg").toString();